import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import AirCompressorsMaintenanceRecordAddForm from './air-compressors-maintenance-record-add-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMaintenanceRecordsByAirCompressorId, fetchMaintenanceRecordsDetails } from './store/slice';
import { selectAirCompressorMaintenanceRecordsData, selectMaintenanceRecordData } from './store/selectors';
import { format } from 'date-fns';

const initData = {
  workOrderNumber: '',
  date: '',
  description: '',
  maintenanceType: '1',
  personnelName: '',
  downTime: '',
  pictures: '',
  serviceRecords: [],
  personnelRecords: [
    {
      personnelName: '',
      startTime: new Date().toISOString().slice(0, 16),
      endTime: new Date().toISOString().slice(0, 16),
    },
  ],
};

const formatDate = date => {
  if (!date) return '--';
  try {
    return format(new Date(date), 'MM/dd/yyyy');
  } catch (error) {
    return '--';
  }
};

const MaintenanceHistory = ({ data, airCompressorsId, onCloseModal }) => {
  const dispatch = useDispatch();
  const [showMaintenanceHistory, setShowMaintenanceHistory] = useState(true);
  const [formData, setFormData] = useState(initData);
  const [viewingRecord, setViewingRecord] = useState(null);
  const [maintenanceRecordId, setMaintenanceRecordId] = useState(null);

  const airCompressorMaintenanceRecordsData = useSelector(selectAirCompressorMaintenanceRecordsData);
  const maintenanceRecordData = useSelector(selectMaintenanceRecordData);

  useEffect(() => {
    if (airCompressorsId) {
      dispatch(fetchMaintenanceRecordsByAirCompressorId(airCompressorsId));
    }
  }, [airCompressorsId]);

  useEffect(() => {
    if (viewingRecord && maintenanceRecordData?.workOrderNumber) {
      setFormData(maintenanceRecordData);
      setShowMaintenanceHistory(false);
    }
  }, [viewingRecord, maintenanceRecordData]);

  const handleViewClick = record => {
    setViewingRecord(record);
    dispatch(fetchMaintenanceRecordsDetails(record.id));
  };

  const handleMaintenanceRecord = () => {
    setFormData(initData); // reset form to empty
    setShowMaintenanceHistory(!showMaintenanceHistory);
    setViewingRecord(null);
    setMaintenanceRecordId(null);
  };

  const handleEditClick = record => {
    setViewingRecord(record);
    setMaintenanceRecordId(record.id);
    dispatch(fetchMaintenanceRecordsDetails(record.id));
  };

  const columns = [
    {
      title: 'Work Order Number',
      dataIndex: 'workOrderNumber',
      key: 'workOrderNumber',
      render: (text, record) => (
        <Link
          to="#"
          onClick={e => {
            e.preventDefault();
            handleViewClick(record);
          }}
        >
          {text}
        </Link>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: text => formatDate(text),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Maintenance Type',
      dataIndex: 'maintenanceType',
      key: 'maintenanceType',
    },
    {
      title: 'Personnel Name',
      dataIndex: 'personnelName',
      key: 'personnelName',
    },
    {
      title: 'Down Time',
      dataIndex: 'downTime',
      key: 'downTime',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div>
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => handleEditClick(record)}
          >
            Edit
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="maintenance-history-container">
      <div className="mb-3">
        <button className="btn btn-info me-2" onClick={() => handleMaintenanceRecord()}>
          {showMaintenanceHistory ? '+ Add Maintenance Record' : '← Back to Maintenance History'}
        </button>
      </div>

      {showMaintenanceHistory ? (
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Table columns={columns} dataSource={airCompressorMaintenanceRecordsData} />
          </div>
        </div>
      ) : (
        <AirCompressorsMaintenanceRecordAddForm
          key={formData?.workOrderNumber || 'new'}
          data={formData}
          airCompressorId={airCompressorsId}
          maintenanceRecordId={maintenanceRecordId}
          onCloseModal={onCloseModal}
        />
      )}
    </div>
  );
};

MaintenanceHistory.propTypes = {
  data: PropTypes.object,
  airCompressorsId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCloseModal: PropTypes.func,
};

export default MaintenanceHistory;